document.addEventListener("DOMContentLoaded", function(){

let slides = document.querySelectorAll(".ultra-slide")
let next = document.querySelector(".ultra-next")
let prev = document.querySelector(".ultra-prev")
let progress = document.querySelector(".progress-bar")
let hero = document.querySelector(".ultra-hero")

let index = 0
let duration = 5000
let timer

function showSlide(i){

slides.forEach(slide => slide.classList.remove("active"))

slides[i].classList.add("active")

startProgress()

}

function nextSlide(){

index++

if(index >= slides.length){
index = 0
}

showSlide(index)

}

function prevSlide(){

index--

if(index < 0){
index = slides.length - 1
}

showSlide(index)

}

if(next){
next.onclick = nextSlide
}

if(prev){
prev.onclick = prevSlide
}

function startProgress(){

if(!progress) return

progress.style.transition = "none"
progress.style.width = "0%"

setTimeout(()=>{

progress.style.transition = duration+"ms linear"
progress.style.width = "100%"

},50)

clearTimeout(timer)

timer = setTimeout(nextSlide,duration)

}

startProgress()

/* swipe support */

let startX = 0

if(hero){

hero.addEventListener("touchstart",e=>{
startX = e.touches[0].clientX
})

hero.addEventListener("touchend",e=>{

let endX = e.changedTouches[0].clientX

if(startX - endX > 50){
nextSlide()
}

if(endX - startX > 50){
prevSlide()
}

})

}

})